import { Button, Input, InputNumber } from "antd";
import classNames from "classnames";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

export default function HBInputNumber({ value, max, min, disabled, onChange }) {
  return (
    <Input.Group className={styles.inputGroup} compact>
      <Button
        className={classNames([styles.button, styles.left])}
        disabled={value <= min || disabled}
        size="small"
        icon={<HBIcon className={styles.icon} type="minus" />}
        onClick={() => onChange(value - 1)}
      />
      <InputNumber
        className={styles.input}
        value={value}
        size="small"
        disabled={disabled}
        controls={false}
        bordered={false}
        onChange={onChange}
        max={max}
        min={min}
      />
      <Button
        className={classNames([styles.button, styles.right])}
        disabled={value >= max || disabled}
        size="small"
        icon={<HBIcon className={styles.icon} type="plus" />}
        onClick={() => onChange(value + 1)}
      />
    </Input.Group>
  );
}
